import React, {useEffect} from 'react';
import './RatePlanItem.scss';
import {isZero} from "../../../utils/helper";

const RatePlanItem = ({ item, originUrlRedirection, translation, handleProductClick,lang }) => {
    return (
        <li
            className="rate-plan-item"
            onClick={() => handleProductClick(item)}
        >
            {item.discount && (
                <div
                className="rate-plan-discount"
                dangerouslySetInnerHTML={{ __html: item.discount }}
                />
            )}
            <div className="rate-plan-content">
                <div className="rate-plan-left">
                    <div className="rate-plan-info">
                        <div className="rate-plan-name">
                            {(item?.mainName || item?.subName) ? (
                                <>
                                    <span className="first-word">{item?.subName}</span>
                                    <span className="rest-of-name">{item?.mainName}</span>
                                </>
                            ) : (
                                <span className="first-word">{item?.displayName}</span>
                            )}
                        </div>

                        <ul className="characteristics-list">
                            {item.characteristics?.map((charac, idx) => (
                                <li key={idx}>
                                    {charac.imageUrl && (
                                        <img
                                            src={originUrlRedirection + charac.imageUrl}
                                            alt={charac.name}
                                            className="characteristic-icon"
                                        />
                                    )}
                                    <span
                                        dangerouslySetInnerHTML={{ __html: charac.description }}
                                    />
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
                <div className="rate-plan-right">
                    {((item?.initialPrice && !isZero(item?.initialPrice) )||( item.finalPrice && !isZero(item?.finalPrice))) ?
                        <span className="rate-plan-price-title">
                            {translation('monthlyPay')}
                        </span>
                    : lang?.toLowerCase() === 'en' ? "Free" : "Δωρεάν"}
                    {(item?.initialPrice && item?.initialPrice !== item.finalPrice && !isZero(item?.initialPrice))  ? <span className="old-price">{item.initialPrice?.toFixed(2)}€</span> : ""}
                    {item.finalPrice && !isZero(item?.finalPrice) ? <span className="new-price"  style={(isZero(item?.initialPrice) || item?.initialPrice !== item?.finalPrice) ? { color: '#E20074' } : {}}>{item.finalPrice?.toFixed(2)}€</span> : ""}
                </div>
            </div>
        </li>
    );
};

export default RatePlanItem;
